/* tslint:disable */
/* eslint-disable */
/**
 * FleetManagement Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnitValueDto
 */
export interface UnitValueDto {
    /**
     * 
     * @type {number}
     * @memberof UnitValueDto
     */
    value?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitValueDto
     */
    unit?: string;
}

export function UnitValueDtoFromJSON(json: any): UnitValueDto {
    return UnitValueDtoFromJSONTyped(json, false);
}

export function UnitValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnitValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'value': !exists(json, 'value') ? undefined : json['value'],
        'unit': !exists(json, 'unit') ? undefined : json['unit'],
    };
}

export function UnitValueDtoToJSON(value?: UnitValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'value': value.value,
        'unit': value.unit,
    };
}


